import React from "react";
import AddIcon from "@mui/icons-material/Add";

function AddButtonRound(props) {
  return (
    <div
      className="add-round-button"
      onClick={props.handleOpen}
      title={props.title}
    >
      <AddIcon fontSize="small" />
    </div>
  );
}

export default AddButtonRound;
